module.exports = __webpack_public_path__ + "static/img/PT.03b6df0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/userTips/PT.png
// module id = 141d
// module chunks = 1